<template>
  <div class="tjCase">
    <div class="posit">
      <span>当前位置：&nbsp;</span>
      <span>优秀企业推介</span>
      <span style="margin: 0 10px">></span>
      <span>案例中心</span>
    </div>

    <div class="companys">
      <div class="companysContent">
        <div class="product">
          <el-row type="flex">
            <el-col
              :span="6"
              v-for="(item,index) in accountList.slice( (pageIndex - 1) * pageSize, pageIndex * pageSize )"
              :key="index"
            >
              <div class="product_event" @click="caseInfo(item.id)">
                <p class="img_p">
                  <img :src="$getSrc(item.image)" alt />
                </p>
                <p class="text_p">{{ item.title }}</p>
                <div class="bottom">
                  <p>
                    <img :src="$getSrc(item.logo)" alt />
                  </p>
                  <p>{{ item.company }}</p>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabName: "全部",
      pageSize: 16, // 每页条数
      pageIndex: 1, // 当前页
      accountList: [], // 企业list
      tiaoPage: "",
      totalIndex: 0,
      content: "",
      title: "",
      time: "",
      watch: "", // 浏览
      fabulous: 0, // 点赞
      tips: "",
    };
  },
  activated() {
    this.caseInit();
  },
  created() {
  },
  mounted() {
    var _this = this;
    window.addEventListener("scroll", function () {
      var scr = document.documentElement.scrollTop || document.body.scrollTop; // 向上滚动的那一部分高度
      var clientHeight = document.documentElement.clientHeight; // 屏幕高度也就是当前设备静态下你所看到的视觉高度
      var scrHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight; // 整个网页的实际高度，兼容Pc端
      if (scr + clientHeight + 100 >= scrHeight) {
        _this.loadMore();
      }
    });
  },
  methods: {
    caseInit() {
      this.$http({
        url: "promotion/getTjContent",
        method: "post",
        params: {
          type: "7",
        },
      })
        .then(({ data }) => {
          let { code, promotion } = data;
          if (code === 0) {
            this.accountList = promotion;
          }
        })
        .catch((err) => console.log(err));
    },

    caseInfo(id) {
      sessionStorage.setItem("coreId", true);
      this.$router.push({
        path: "/caseDetail",
        query: {
          detailId: id,
        },
      });
    },
    loadMore() {
      this.pageSize += this.pageSize;
      if (this.pageSize >= this.accountList.length) {
        this.pageSize = this.accountList.length;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tjCase {
  .posit {
    margin: 31px 0 32px 0;
    padding-left: 25px;
    color: #999999;
    font-size: 12px;
  }
  .companys {
    //   width: 844px;
    //   min-height: 542px;
    //   margin-top: 20px;
    .companysTop {
      height: 115px;
      border-bottom: 1px solid #bbbbbb;
      .left {
        width: 314px;
        height: 100%;
        float: left;
        img {
          width: 217px;
          height: 80px;
          margin: 20px 0 0 24px;
        }
      }
      .right {
        width: 530px;
        height: 100%;
        float: right;
        font-size: 16px;
        line-height: 33px;
        p:first-child {
          margin-top: 26px;
        }
      }
    }
    .companysContent {
      .product_event {
        width: 258px;
        height: 292px;
        border: 1px solid #f3f3f3;
        border-radius: 10px 10px 0 0;
        margin: auto;
        cursor: pointer;
        .img_p {
          width: 100%;
          height: 193px;
          border-radius: 10px 10px 0 0;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            // width: 100%;
            // height: 100%;
            // border-radius: 10px 10px 0 0;
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
            display: inline-block;
            vertical-align: middle;
          }
        }
        .text_p {
          width: 230px;
          height: 16px;
          line-height: 16px;
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          margin: 21px 0 12px 11px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .bottom {
          border-top: 1px solid #e5e5e5;
          p:first-child {
            width: 43px;
            height: 12px;
            margin: 21px 8px 0 17px;
            float: left;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              max-width: 100%;
              max-height: 100%;
              width: auto;
              height: auto;
              display: inline-block;
              vertical-align: middle;
            }
          }
          p:last-child {
            font-size: 12px;
            color: #bbbbbb;
            width: 172px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            float: right;
            height: 12px;
            line-height: 12px;
            margin: 21px 11px 0 0;
          }
        }
      }
      .load {
        width: 148px;
        height: 40px;
        font-size: 16px;
        text-align: center;
        line-height: 42px;
        border: 1px solid #a3a3a3;
        margin: 40px auto 98px;
        cursor: pointer;
      }
      .el-row {
        flex-wrap: wrap;
        min-height: 309px;
        margin-bottom: 98px;
      }
      .el-col {
        margin-top: 15px;
      }
    }
  }
  // .detail {
  //   width: 1119px;
  //   min-height: 892px;
  //   margin: 54px auto 0;
  //   .content_top {
  //     height: 110px;
  //     border-bottom: 1px solid #dfe1e1;
  //     position: relative;
  //     text-align: center;
  //     .content_top_title {
  //       padding: 0 24px 17px 10px;
  //       line-height: 45px;
  //       font-size: 28px;
  //     }
  //     span {
  //       color: #bbbbbb;
  //       font-size: 12px;
  //     }
  //   }
  //   .content_center {
  //     min-height: 1014px;
  //     padding: 20px 0;
  //   }
  //   .content_bottom {
  //     height: 258px;
  //     border-top: 1px solid #dfe1e1;
  //     margin-top: 30px;
  //     .left {
  //       float: left;
  //       margin: 63px 276px 0 38px;
  //       img:first-child {
  //         margin-right: 8px;
  //       }
  //     }
  //     .center {
  //       float: left;
  //       width: 186px;
  //       height: 66px;
  //       background-color: #7eb341;
  //       border-radius: 50px;
  //       line-height: 186px;
  //       margin-top: 51px;
  //       img {
  //         float: left;
  //         margin: 20px 0 0 32px;
  //       }
  //       p {
  //         float: right;
  //         height: 66px;
  //         line-height: 66px;
  //       }
  //       .num {
  //         font-size: 14px;
  //         color: #c5dbb1;
  //         margin: 0 30px 0 55px;
  //       }
  //       p:last-child {
  //         color: #ffffff;
  //         font-size: 18px;
  //       }
  //     }
  //   }
  // }
}
</style>